module.exports = __webpack_public_path__ + "img/08.88aa6c29.jpg";